// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d5edaba9","239":"c457a42e","334":"605b97e9","667":"b78ed3d2","735":"b998adb8"}[chunkId] + ".chunk.js";
};